import i18n from 'modules/core/lib/i18n'

type Props = {
  string: string
  minLength?: number
  maxLength?: number
}

const validateString = ({ string, minLength = 1, maxLength = 250 }: Props) => {
  const isValid = string.length >= minLength && string.length <= maxLength
  const message = isValid ? '' : i18n.t('importer_process.edition_step.validators.string')

  return { isValid, message }
}

export default validateString
